import React from "react";
import { connect } from "react-redux";
import DynamicMainScreen from "../../../components/dynamicscreens/DynamicMainScreen";
import { BrandColumns } from "../../../tableColumns/table-columns";
import { BrandJson } from "../../../DynamicFormsJson/MastersJSON/brand";
import { getBrand } from "../../../Slice/brand.slice";
import endpoint from "../../../config/endpoints";
import {
  deleteFailedMsg,
  deletemsg,
  deleteWarningMsg,
  serverMsg,
} from "../../../config/messageconstant";
import { apiDelete } from "../../../utils/api_service";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
class BrandTable extends React.Component {
  constructor(props) {
    super(props);
  }

  rowDelete = (rowData) => {
    const { showNotification, showLoador } = this.props;

    if (rowData.id) {
      showLoador({ loador: true });
      apiDelete({
        url: endpoint.brand + "/" + rowData.id,
      }).then(({ data, success }) => {
        showLoador({ loador: false });
        if (success) {
          if (data && data.data && data.data.statusCode == 200) {
            showNotification({ msg: deletemsg });
            window.location.reload();
          } else {
            showNotification({ msg: deleteFailedMsg, severity: "error" });
          }
        } else {
          showNotification({
            msg: serverMsg,
            severity: "error",
          });
        }
      });
    }
  };

  render() {
    const { brandList, getBrand } = this.props;
    return (
      <>
        <DynamicMainScreen
          formPath={BrandJson.formPath}
          screenTitle={BrandJson.screenTitle}
          fieldMeta={BrandJson.fieldMeta}
          showPdfDownload={BrandJson.showPdfDownload}
          showExcelDownload={true}
          changeExcelURL={BrandJson.excelUrl}
          showExtension={false}
          filterDataExcel={true}
          pdfFileName={BrandJson.pdfFileName}
          excelFileName={BrandJson.excelFileName}
          showAddButton={BrandJson.showAddButton}
          tableColumnsToFilter={BrandJson.tableColumnsToFilter}
          tableColumns={BrandColumns}
          tableData={brandList?.brand}
          getTableData={getBrand}
          apiBaseURL={BrandJson.apiBaseURL}
          baseIdColumn={BrandJson.baseIdColumn}
          isNote={true}
          isNoteValue={"Brand"}
          showDeleteIcon={true}
          isLog={true}
          type={0}
          deleteURLStatic={true}
          onDeleteStatic={this.rowDelete}
          showViewButtonInTable={true}
          formPathView={BrandJson.formPathView}
        />
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  brandList: state.brand,
});
const mapDispatchToProps = {
  getBrand,
  showLoador,
  showNotification,
};
export default connect(mapStateToProps, mapDispatchToProps)(BrandTable);
